import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-token-ux',
  templateUrl: './token-ux.component.html',
  styleUrls: ['./token-ux.component.css']
})
export class TokenUxComponent implements OnInit {
  token: string = '';
  showToken: boolean = false;

  ngOnInit(): void {
    const userStr = sessionStorage.getItem('wOSUser') || '{}';
    const parsedUser = JSON.parse(userStr);
    this.token = parsedUser?.stsTokenManager?.accessToken || '';
  }

  generateToken(): void {
    if (this.token) {
      this.showToken = true;
    } else {
      alert('No Firebase token found in sessionStorage.');
    }
  }

  copyToken(): void {
    navigator.clipboard.writeText(this.token);
    alert('Token copied to clipboard!');
  }
}
